import { useNavLinks } from "hooks/useNavLinks";
import { NavLink } from "react-router-dom";
import './NavApp.scss';

export function NavApp({ showMenu = true }) {
    const { navLinks, loading } = useNavLinks();
    const navClassname = showMenu ? 'nav--show' : 'nav';

    if (!loading) {
        // console.log({ navLinks })
    }

    return (
        <nav className={navClassname}>
            <ul className="nav__list">
                {
                    navLinks.map(link => {
                        return (
                            <li
                                key={link.id}
                                className="nav__item"
                            >
                                {
                                    link.isExternal
                                        ? <a href={link.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="nav__link"
                                        >{link.text}</a>
                                        : <NavLink
                                            to={link.href}
                                            className="nav__link"
                                            exact
                                        >{link.text}</NavLink>
                                }
                            </li>
                        )
                    })
                }
            </ul>
        </nav>
    )
}